import {
  FetchKycDataForApprovalRequest,
  FetchKycDataForApprovalResponse,
} from "@services/models/Kyc/FetchKycDataForApprovalModel";
import {
  UpdateKYCStatusRequest,
  UpdateKYCStatusResponse,
} from "@services/models/Kyc/UpdateKYCStatusModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class KycApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async fetchKYCRecords(
    data?: FetchKycDataForApprovalRequest
  ): Promise<FetchKycDataForApprovalResponse> {
    try {
      const params: Record<string, any> = {};
      if (data) {
        params.limit = data.limit;
        params.page = data.page;
        if (data.search) {
          params.search = data.search;
        }
        if (data.overallKycStatus) {
          params.overallKycStatus = data.overallKycStatus;
        }
        if (data.accountType) {
          params.accountType = data.accountType;
        }
      }

      const response = await this.api.get<FetchKycDataForApprovalResponse>(
        "/adminPanel/fetchKYCRecords",
        {
          params,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async updateKYCStatus(
    data: UpdateKYCStatusRequest
  ): Promise<UpdateKYCStatusResponse> {
    try {
      const response = await this.api.post<UpdateKYCStatusResponse>(
        "adminPanel/updateKYC",
        {
          userId: data.userId,
          poiStatus: data.poiStatus,
          poaStatus: data.poaStatus,
          overallKycStatus: data.overallKycStatus,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const kycService = new KycApiService();
